import { createActionConst } from '../../../utils/action.utils';

const USER_NAMESPACE = 'USER';

export const SEARCH_USERS = createActionConst(USER_NAMESPACE, 'SEARCH_USERS');

export const STORE_USER = createActionConst(USER_NAMESPACE, 'STORE_USER');
export const CLEAR_USER = createActionConst(USER_NAMESPACE, 'CLEAR_USER');
